import moment from 'moment';
import mock from 'src/utils/mock';

mock.onGet('/api/finance').reply(() => {
  const orders = [
    {
      id: '5ecb8a6d9f53bfae09e16115',
      createdAt: moment()
        .subtract(32, 'minutes')
        .subtract(23, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Cao Yu'
      },
      number: 'DEV-102',
      payment: {
        service: 'Laser',
        serviceDetails: 'Note for the service',
        totalAmount: 1300.00,
        collectedPayment: 300.00,
        underpayment: -1000.00,
        accountBalance: 300.00,
        paymentMethod: 'Cash',
        discount:'5%',
        discountPrice: 1300.00,
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Daisy',
      commission: '130',
      comment: '',
    },
    {
      id: '5ecb8a738aa6f3e577c2b3ec',
      createdAt: moment()
        .subtract(36, 'minutes')
        .subtract(51, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Alex Richardson'
      },
      number: 'DEV-101',
      payment: {
        service: 'Laser',
        serviceDetails: 'Note for the service',
        totalAmount: 1100.00,
        collectedPayment: 1100.00,
        underpayment: 0.00,
        accountBalance: 0.00,
        paymentMethod: 'Cash',
        discount:'5%',
        discountPrice: 1100.00,
        cardNumber: 1234,
        paymentStatus: 'completed',
      },
      beautician: 'Sissi',
      commission: '80',
      comment: ''
    },
    {
      id: '5ecb8a795e53f134013eba3b',
      createdAt: moment()
        .subtract(38, 'minutes')
        .subtract(55, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Anje Keizer'
      },
      number: 'DEV-100',
      payment: {
        service: 'Laser',
        serviceDetails: 'Note for the service',
        totalAmount: 699.00,
        collectedPayment: 400.00,
        underpayment: -299.00,
        accountBalance: 400.00,
        paymentMethod: 'Cash',
        discount:'',
        discountPrice: '',
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Summer',
      commission: '41.94',
      comment: '',
    },
    {
      id: '5ecb8a7f738cc572a9ce0277',
      createdAt: moment()
        .subtract(40, 'minutes')
        .subtract(3, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Clarke Gillebert'
      },
      number: 'DEV-99',
      payment: {
        service: 'Facial',
        serviceDetails: 'Note for the service',
        totalAmount: 140.00,
        collectedPayment: 140.00,
        underpayment: 0.00,
        accountBalance: 140.00,
        paymentMethod: 'Cash',
        discount:'',
        discountPrice: '',
        cardNumber: 1234,
        paymentStatus: 'complete',
      },
      beautician: 'Carmen',
      commission: '11.2',
      comment: '',
    },
    {
      id: '5e86805e2bafd54f66cc95c3',
      createdAt: moment()
        .subtract(45, 'minutes')
        .subtract(32, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Adam Denisov'
      },
      number: 'DEV-98',
      payment: {
        service: 'Aromatherpy',
        serviceDetails: 'Note for the service',
        totalAmount: 300.00,
        collectedPayment: 300.00,
        underpayment: 0.00,
        accountBalance: 300.00,
        paymentMethod: 'Cash',
        discount:'7%',
        discountPrice: 300.00,
        cardNumber: 1234,
        paymentStatus: 'complete',
      },
      beautician: 'Angel',
      commission: '30',
      comment: '',
    },
    {
      id: '5ecb8a85a850c16fa413849c',
      createdAt: moment()
        .subtract(48, 'minutes')
        .subtract(57, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Miller Edwards'
      },
      number: 'DEV-97',
      payment: {
        service: 'Facial',
        serviceDetails: 'Note for the service',
        totalAmount: 300.00,
        collectedPayment: 100.00,
        underpayment: -200,
        accountBalance: 100,
        paymentMethod: 'Jessica Card',
        discount:'Tax Free',
        discountPrice: 300.00,
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Grace',
      commission: '30',
      comment: '',
    },
    {
      id: '5ecb8a8e69ba2e409ea0168f',
      createdAt: moment()
        .subtract(49, 'minutes')
        .subtract(4, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Emilee Simchenko'
      },
      number: 'DEV-96',
      payment: {
        service: 'Body Sculpting',
        serviceDetails: 'Note for the service',
        totalAmount: 880.00,
        collectedPayment: 400.00,
        underpayment: -480.00,
        accountBalance: 400.00,
        paymentMethod: 'Sissi Card',
        discount:'',
        discountPrice: '',
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Yan',
      commission: '44',
      comment: '',
    },
    {
      id: '5ecb8a9341c68839d387e1c4',
      createdAt: moment()
        .subtract(57, 'minutes')
        .subtract(43, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Elliott Stone'
      },
      number: 'DEV-95',
      payment: {
        service: 'Botox / Others',
        serviceDetails: 'Note for the service',
        totalAmount: 50.00,
        collectedPayment: 50.00,
        underpayment: 0.00,
        accountBalance: 50.00,
        paymentMethod: 'Cash',
        discount:'',
        discountPrice: '',
        cardNumber: 1234,
        paymentStatus: 'completed',
      },
      beautician: 'Grace',
      commission: '30',
      comment: '',
    },
    {
      id: '5ecb8a984bfbb97c9ae458e8',
      createdAt: moment()
        .subtract(59, 'minutes')
        .subtract(6, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Shen Zhi'
      },
      number: 'DEV-94',
      payment: {
        service: 'Body Sculpting',
        serviceDetails: 'Note for the service',
        totalAmount: 380.00,
        collectedPayment: 280.00,
        underpayment: -100.00,
        accountBalance: 280.00,
        paymentMethod: 'Cash',
        discount:'3%',
        discountPrice: 380.00,
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Yan',
      commission: '19',
      comment: '',
    },
    {
      id: '5ecb8aa08d9127dba654ce7a',
      createdAt: moment()
        .subtract(1, 'hour')
        .subtract(15, 'minutes')
        .subtract(43, 'seconds')
        .toDate()
        .getTime(),
      currency: '$',
      customer: {
        name: 'Merrile Burgett'
      },
      number: 'DEV-93',
      service: 'Products',
      serviceDetails: 'Note for the service',
      totalAmount: 190.00,
      payment: {
        collectedPayment: 190.00,
        underpayment: 0.00,
        accountBalance: 190.00,
        paymentMethod: 'Jessica Card',
        discount:'5%',
        discountPrice: 190.00,
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      beautician: 'Tina',
      commission: '15.2',
      comment: '',
    }
  ];

  return [200, { orders }];
});

mock.onGet('/api/orders/1').reply(() => {
  const order = {
    id: '5ecb8a6879877087d4aa2690',
    coupon: null,
    createdAt: moment()
      .toDate()
      .getTime(),
    currency: '$',
    customer: {
      address1: 'Street John Wick, no. 7',
      address2: 'House #25',
      city: 'San Diego',
      country: 'USA',
      name: 'Adam Denisov'
    },
    referral: [
      {
        id: '5ecb8abbdd6dfb1f9d6bf98b',
        beautician: 'Daisy',
        currency: '$',
        bouns: 27.96
      },
      {
        id: '5ecb8ac10f116d04bed990eb',
        beautician: 'Grace',
        currency: '$',
        bouns: 13.98
      }
    ],
    payment: [
      {
        collectedPayment: 100.00,
        underpayment: -400.00,
        accountBalance: 100.00,
        paymentMethod: 'Cash',
        discount:'5%',
        discountPrice: 500.00,
        cardNumber: 1234,
        paymentStatus: 'pending',
      },
      {
        collectedPayment: 200,
        underpayment: -200.00,
        accountBalance: 300.00,
        paymentMethod: 'Daisy Quick Pay / Paypal',
        discount:'5%',
        discountPrice: 500.00,
        cardNumber: 1234,
        paymentStatus: 'completed',
      },
      {
        collectedPayment: 200,
        underpayment: 0.00,
        accountBalance: 500.00,
        paymentMethod: 'Sissi Card',
        discount:'5%',
        discountPrice: 500.00,
        cardNumber: 1234,
        paymentStatus: 'completed',
      }
    ],
    number: 'DEV-103',
    paymentMethod: 'Cash',
    status: 'pending',
    totalAmount: 500.00
    
  };

  return [200, { order }];
});
